module.exports = __webpack_public_path__ + "static/media/logo-오픈엣지@3x.cc3fb93e.png";